export default "__VITE_ASSET__9eec762a__"